// example of enum object
//
// export const UserType = {
//   Internal: "Internal",
//   External: "External",
// };

export const Sort = {
  Asc: "Asc",
  Desc: "Desc",
};

export const enumOptionsArray = (enumObj) => {
  return Object.keys(enumObj).map((k) => ({ value: k, text: enumObj[k] }));
};

export const SitePermission = {
  None: "None",
  View: "View",
  Edit: "Edit",
};

export const SitePermissionItemType = {
  Site: "Site",
  Directory: "Directory",
  File: "File",
};

export const GroupStatus = {
  Active: "Active",
  Inactive: "Inactive",
};

export const NotificationFrequency = {
  Never: "Never",
  Adhoc: "Adhoc",
  Daily: "Daily",
  Weekly: "Weekly",
  Monthly: "Monthly",
};

export const NotificationFrequencyLabels = {
  [NotificationFrequency.Never]: "Never",
  [NotificationFrequency.Adhoc]: "Ad-hoc",
  [NotificationFrequency.Daily]: "Daily",
  [NotificationFrequency.Weekly]: "Weekly",
  [NotificationFrequency.Monthly]: "Monthly",
};

// picker-only frequency; the api models inheriting from the parent as having no setting at all
export const InheritNotificationFrequency = "Inherit";

export const NotificationActivity = {
  Upload: "Upload",
  Download: "Download",
  FolderCreated: "FolderCreated",
  Edit: "Edit",
  Move: "Move",
  Delete: "Delete",
  View: "View",
};

export const NotificationActivityLabels = {
  [NotificationActivity.Upload]: "Uploads",
  [NotificationActivity.Download]: "Downloads",
  [NotificationActivity.FolderCreated]: "New folders",
  [NotificationActivity.Edit]: "Edits",
  [NotificationActivity.Move]: "Moves",
  [NotificationActivity.Delete]: "Deletes",
  [NotificationActivity.View]: "Views",
};

// a document cannot be uploaded into or have folders created inside it
export const FileNotificationActivities = [
  NotificationActivity.Download,
  NotificationActivity.Edit,
  NotificationActivity.Move,
  NotificationActivity.Delete,
  NotificationActivity.View,
];

export const EntityType = {
  File: "File",
  Directory: "Directory",
  Site: "Site",
};

export const UserStatus = {
  Active: "Active",
  Unverified: "Unverified",
  Inactive: "Inactive",
};

export const UserAuthType = {
  SsoEnabled: "SsoEnabled",
  PasswordOnly: "PasswordOnly",
  NotApplicable: "NotApplicable",
  MfaNotEnrolled: "MfaNotEnrolled",
  MfaEnforced: "MfaEnforced",
  MfaActive: "MfaActive",
};

export const UserAuthTypeLabels = {
  [UserAuthType.SsoEnabled]: "SSO Enabled",
  [UserAuthType.PasswordOnly]: "Password / Magic Link",
  [UserAuthType.NotApplicable]: "Not Applicable",
  [UserAuthType.MfaNotEnrolled]: "Not Enrolled",
  [UserAuthType.MfaEnforced]: "MFA Enforced",
  [UserAuthType.MfaActive]: "MFA Active",
};

export const AuditType = {
  Created: "Created",
  Updated: "Updated",
  Downloaded: "Downloaded",
  Deleted: "Deleted",
  Shared: "Shared",
  Activated: "Activated",
  Deactivated: "Deactivated",
  Moved: "Moved",
  Restored: "Restored",
  Viewed: "Viewed",
};

export const AuditTypeLabels = {
  [AuditType.Created]: "Created",
  [AuditType.Updated]: "Updated",
  [AuditType.Downloaded]: "Downloaded",
  [AuditType.Deleted]: "Deleted",
  [AuditType.Shared]: "Shared",
  [AuditType.Activated]: "Activated",
  [AuditType.Deactivated]: "Deactivated",
  [AuditType.Moved]: "Moved",
  [AuditType.Restored]: "Restored",
  [AuditType.Viewed]: "Viewed",
};
